module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-18.ce182983.png";